import React, { ReactNode } from 'react';

import Icon from './Icon';

interface Props {
  crumbs: string[];
  tools?: ReactNode;
}

// Breadcrumb bar pinned to the top of every v3 page.  Last segment is bold
// ink, earlier segments muted with `/` separators (rendered by the component,
// not provided by the caller).

const Topbar = ({ crumbs, tools }: Props) => (
  <header className="topbar">
    <div className="crumbs">
      {crumbs.map((c, i) => (
        <React.Fragment key={`${i}-${c}`}>
          {i > 0 && <span className="sep">/</span>}
          {i === crumbs.length - 1 ? <strong>{c}</strong> : <span>{c}</span>}
        </React.Fragment>
      ))}
    </div>
    <div className="tb-actions">
      {tools}
      {/*
        Bell + Calendar slots are visual-only until the notification /
        agenda streams are wired.  Tooltip flags the un-wired state so
        users don't repeatedly click a dead icon.
      */}
      <div
        className="tb-icon stub"
        aria-label="Notifications"
        title="Notifications — coming soon"
      >
        <Icon name="bell" size={17} />
      </div>
      <div className="tb-icon stub" aria-label="Calendar" title="Agenda — coming soon">
        <Icon name="calendar" size={17} />
      </div>
    </div>
  </header>
);

export default Topbar;
